export const formatCurrency = (value) => {
  if (value === null || value === undefined || isNaN(value)) return '-';
  if (value === 0) return '-';
  
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
};

export const formatNumber = (value) => {
  if (value === null || value === undefined || isNaN(value)) return '-';
  if (value === 0) return '-';
  
  return new Intl.NumberFormat('en-US').format(value);
};

export const formatPercentage = (value) => {
  if (value === null || value === undefined || isNaN(value)) return '-';
  if (value === 0) return '-';
  
  return `${value.toFixed(1)}%`;
}; 